import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

/**
 * ErrorBoundary — filet de sécurité défensif.
 * NE remplace PAS la correction de la cause racine (traduction navigateur désactivée),
 * mais évite qu'une erreur inattendue ne bloque toute l'application.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Journalisation légère pour le diagnostic (pas de masquage de la cause).
    // eslint-disable-next-line no-console
    console.error("[ASL ErrorBoundary]", error, info?.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-background px-4" data-testid="error-boundary">
          <div className="w-full max-w-md rounded-2xl border bg-card p-8 text-center shadow-sm">
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10">
              <AlertTriangle className="h-6 w-6 text-destructive" />
            </div>
            <h1 className="font-heading text-xl font-bold text-foreground">Une erreur est survenue</h1>
            <p className="mt-2 text-sm text-muted-foreground">
              Un problème inattendu s'est produit. Vous pouvez réessayer sans perdre votre session.
            </p>
            <button
              onClick={this.handleReset}
              data-testid="error-boundary-retry"
              className="mt-6 inline-flex items-center justify-center gap-2 rounded-lg bg-secondary px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-emerald-600"
            >
              <RefreshCw className="h-4 w-4" /> Réessayer
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
